import { STATUS, DATE, REGISTRATIONS, SUB_ORGANIZATION, NAME, META, EDITOR, ALL, DAYS } from 'store/planning';

export const STATUS_OPTIONS = [
  { id: ALL, title: 'Alle' },
  { id: '0', title: 'In Vorbereitung' },
  { id: '1', title: 'Geplant' },
  { id: '2', title: 'Gestartet' },
  { id: '3', title: 'Abgeschlossen' },
];

export const TABLE_HEAD = [
  { id: DATE, content: 'Datum', width: '14%' },
  { id: DAYS, content: 'Tage', width: '6%', withoutSort: true },
  { id: REGISTRATIONS, content: 'Anmeldungen', width: '13%', withoutSort: true },
  { id: `${SUB_ORGANIZATION}.${NAME}`, content: 'Institution', width: '40%', withoutSort: true },
  { id: `${META}.${EDITOR}`, content: 'Zul. bearbeitet', width: '14%', withoutSort: true },
  { id: STATUS, content: 'Status', width: '13%' },
];
